import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from './modules/user'
import language from './modules/language'
import cart from './modules/cart'
import ui from './modules/ui'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexLocalStorage = createPersistedState({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    language: state.language,
    cart: state.cart
  })
})

export default new Vuex.Store({
  plugins: [vuexLocalStorage],
  modules: {
    user,
    cart,
    language,
    ui
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/vuex/store.js